<template>
    <div class="bg-white p-6 rounded-lg shadow-lg">
        <h3 class="text-lg font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">⏰</span> Hours Per Week by Program
        </h3>
        <div class="h-80">
            <apexchart type="bar" height="100%" :options="barOptions" :series="barSeries" />
        </div>
    </div>
</template>

<script>
export default {
    name: "HrPerWeekChart",
    props: {
        hrPerWeekData: {
            type: Array,
            required: true
        },
        powerBiColors: {
            type: Array,
            required: true
        }
    },
    computed: {
        barOptions() {
            const labels = this.hrPerWeekData.map(item => item.program);

            return {
                chart: {
                    type: 'bar',
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '55%',
                        endingShape: 'rounded',
                        distributed: true
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val + " hrs"
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: labels,
                    labels: {
                        style: {
                            fontSize: '12px'
                        }
                    },
                    title: {
                        text: 'Hours'
                    },
                },
                fill: {
                    opacity: 1,
                    colors: this.powerBiColors.slice(0, labels.length)
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " hours"
                        }
                    }
                },
                legend: {
                    formatter: function (val, opts) {
                        return val + " - " + opts.w.globals.series[0][opts.seriesIndex];
                    }
                },
                colors: this.powerBiColors.slice(0, labels.length)
            };
        },
        barSeries() {
            return [{
                name: 'Total Hours',
                data: this.hrPerWeekData.map(item => item.total_hr_per_week)
            }];
        }
    }
};
</script>
